import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { apiUrl } from "../config/apiUrl";

const Seo = ({ metaTitle, metaDescription, metaKeywords }) => {
  const location = useLocation();
  const pathname = location.pathname.replace("/", "") || "home";

  useEffect(() => {
    const defaultSEO = {
      title: "Binary Ops | Innovative Software Solutions",
      description:
        "Binary Ops is a cutting-edge software house delivering innovative solutions in web development, mobile apps, AI, and cloud computing. We transform ideas into powerful digital experiences.",
      keywords:
        "Binary Ops, software development, web development, mobile apps, AI solutions, cloud computing, custom software, IT services",
    };

    const updateMetaTags = (title, description, keywords) => {
      document.title = title;
      document
        .querySelector('meta[name="description"]')
        ?.setAttribute("content", description);
      document
        .querySelector('meta[name="keywords"]')
        ?.setAttribute("content", keywords);
    };

    if (metaTitle || metaDescription || metaKeywords) {
      updateMetaTags(
        metaTitle || defaultSEO.title,
        metaDescription || defaultSEO.description,
        metaKeywords || defaultSEO.keywords
      );
      return;
    }

    const fetchSEOData = async () => {
      try {
        const response = await axios.post(`${apiUrl}blogKeys`, { blogkey: pathname });
        const seoData = response.data?.data?.[pathname];

        updateMetaTags(
          seoData?.meta_title || defaultSEO.title,
          seoData?.meta_description || defaultSEO.description,
          seoData?.meta_key || defaultSEO.keywords
        );
      } catch (error) {
        // console.error("Error fetching SEO data:", error);
        updateMetaTags(defaultSEO.title, defaultSEO.description, defaultSEO.keywords);
      }
    };

    if (!metaTitle && !metaDescription && !metaKeywords) {
      fetchSEOData();
    }
  }, [pathname, metaTitle, metaDescription, metaKeywords]);

  return null;
};

export default Seo;
